import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@merchant-portal/environments/environment';
import { Observable } from 'rxjs';
import { AppVersionResponse } from '../store/app.state';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private readonly API_URL = environment.backend_portal_url + 'app-version';

  constructor(private http: HttpClient) {}

  getAppVersion(): Observable<AppVersionResponse> {
    return this.http.get<AppVersionResponse>(this.API_URL);
  }
}
